export const FETCH_COLLECTIONS_REQUESTED = 'FETCH_COLLECTIONS_REQUESTED';
export const FETCH_COLLECTIONS_SUCCEEDED = 'FETCH_COLLECTIONS_SUCCEEDED';
export const SORT_COLLECTIONS_REQUESTED = 'SORT_COLLECTIONS_REQUESTED';
export const SORT_COLLECTIONS_SUCCEEDED = 'SORT_COLLECTIONS_SUCCEEDED';
export const FILTER_COLLECTIONS_REQUESTED = 'FILTER_COLLECTIONS_REQUESTED';
export const FILTER_COLLECTIONS_SUCCEEDED = 'FILTER_COLLECTIONS_SUCCEEDED';
export const SEARCH_COLLECTIONS_REQUESTED = 'SEARCH_COLLECTIONS_REQUESTED';
export const SEARCH_COLLECTIONS_SUCCEEDED = 'SEARCH_COLLECTIONS_SUCCEEDED';
export const ADD_COLLECTION_BAG_REQUESTED = 'ADD_COLLECTION_BAG_REQUESTED';
export const ADD_COLLECTION_BAG_SUCCEEDED = 'ADD_COLLECTION_BAG_SUCCEEDED';
